(ns motorsaif.i18n.en)

(def ^:private validations
  {:business {:business {:business/name "Business Name"
                         :business/location "Location"
                         :business/misc {:whatsapp-verified "Whatapp not verified"}
                         :business/description "Description"
                         :business/media "Photos"}}
   ;; :login {:user/auth-identity "sf"}
   :request {:request {:request/location "Location"
                       :request/coords "GPS Location"
                       :request/media "Images"
                       :request/description "Description"
                       :request/category "Category"}
             :car {:car/make "Car Make"
                   :car/model "Car Model"
                   :car/year "Car Year"}}})

(def malli {:missing-key "Required"
            :string {:not "should be a string"
                     :min-is-max "should be %1 characters"
                     :between "should be between %1 and %2 characters"
                     :min "should be at least %1 characters"
                     :max "should be at most %1 characters"}
            :invalid-handle "Handle must not have spaces or be too long"
            :invalid-email "Invalid Email"
            :require-images "Please upload photos"})

(def page
  {:not-found "Page not found"
   :home {:motorsaif "MotorSaif"
          :headline "Auto Care Simplified"
          :tagline "Get solutions from local businesses to your automotive requests"
          :browse-requests "Browse Requests"
          :get-started "Get Started"
          :welcome "Welcome %1"
          :with-motorsaif
          {:time "Time is money, save your time by using Motorsaif"
           :title "With MotorSaif"
           :1 "In the comfort of your home or office..."
           :2 "Send request describing your part or car issue"
           :3 "Receive instant messages to your request from local businesses"
           :4 "Decide from multiple quotations with just a single request"}

          :without-motorsaif
          {:title "Without MotorSaif"
           :1 "Drive around industrial areas in search of spare parts or a garage"
           :2 "Spend hours looking for a business to fulfill your request"
           :3 "Your options are limited"}


          :login-signup  "Login / Signup"

          :modifications
          {:title "Modifications"
           :description "Get performance upgrades, a rear camera, infotainment, or sound system"}
          :repairs
          {:title "Repairs"
           :description "Connect with garages that can fix any of your car issues"}
          :parts
          {:title "Parts"
           :description "Source parts you need from scrap yards and part shops"}}
   :feed {:header "Requests"
          :all-requests "Showing all requests"
          :no-results "No requests found with current search. Add more options or clear them all."}

   :forgot-password {:title "Forgot Password"
                     :subtitle "Enter your email to continue. You will enter a code in the next step to log in."
                     :email-placeholder "Email"
                     :submit {:button "Send Code"
                              :email-not-registered "Email not registered"}}

   :login {:title "Login"}

   :business-signup
   {:title "Business Account"
    :get-started "Get Started"
    :terms {:by "By continuing you agree to the "
            :privacy "Privacy Policy"
            :and "and"
            :terms "Terms"}
    :feature-carousel
    {:one "Increase sales by finding new customers"
     :two "View customer requests that need your business"
     :three "Communicate via instant messages"
     :four "Customers can view your profile and go to you directly"}

    :review {:title "Review"
             :user {:title "User Information"
                    :email "Email"
                    :handle "Handle"}
             :form-submit {:success  "Business created! Reloading..."
                           :error "Failed to create. Try again."}
             :business {:title "Business Information"
                        :name "Name"
                        :email "Email"
                        :whatsapp "Whatsapp"
                        :location "Location"
                        :map "Map"
                        :services "Services"}}}

   :sign-up
   {:title "Registration"
    :business
    {:title "Business Account"
     :desc "Gain more customers by responding to their requests"
     :cta "Register Business"}
    :personal
    {:title "Personal Account"
     :desc "Make requests for repairs, parts, or upgrades for your vehicles"
     :cta "Create Account"}}

   :request
   {:header "%1 Request"
    :share "Share"
    :share-action {:title "Car Service Requested"
                   :text "Car service requested"}
    :description "Description"
    :message "Message"
    :request-id "Request ID"
    :filters "Filters"
    :request-type "Request Type"
    :category "Category"
    :vehicle "Vehicle"
    :clipboard {:title "Copy to Clipboard"
                :copied "Copied!"
                :fail "Failed to copy"}
    :condition "Condition"
    :not-found {:heading "Request not found."
                :helper "Request resolved, deleted, or invalid"}}

   :new-request
   {:header "Create Request"
    :submit {:created {:title "Request created!"}
             :invalid {:title "Please fix below issues"}}}


   :edit-request
   {:header "Edit Request"
    :submit {:created {:title "Request saved!"}
             :invalid {:title "Please fix below issues"}}}


   :edit-profile {:header "Edit Profile"}

   :profile
   {:profile "Profile"
    :alerts-off "Turn Alerts Off"
    :nothing-to-show "Nothing to show here yet"
    :alerts "Alerts"
    :logout "Logout"
    :active "Active"
    :history "History"
    :role {:select "Select Account"
           :personal {:title "Personal Account"
                      :description "For your own private car issues"}
           :business {:title "Business Accounts"
                      :description "Get customers by responding to requests"}}}


   :chat {:is-typing "is typing"
          :online "Online"
          :type-placeholder "Type your message"
          :last-seen "last seen %1"
          :media {:choose-images "Choose Images"
                  :max-4 "Maximum 4 photos"
                  :send "Send"
                  :upload-media "Upload Media"}}

   :messages
   {:empty-responded "You have not responded to anyone yet."
    :empty-responses "No responses yet"
    :profile "Show Profile"
    :empty-requests "You have not created \nany requests yet"
    :my-responses "My Responses"
    :live-chat "Live Chat"
    :my-requests "My Requests"
    :media "%1 media"
    :inbox "Inbox"
    :requester-threads {:title "Request"
                        :description "All the responses for your request"}}})

(def step-inputs
  {:services
   {:business-type "Business Type"
    :categories "Categories"
    :year  "Year"
    :year-min "Year Min"
    :year-max "Year Max"
    :select-year "Select Year"
    :makes "Makes"
    :select-make "Select a make"
    :all "All"
    :services "Services"
    :desc-1 "This will show you only the customer requests that you care about"
    :desc-2 "Choose all applicable services you offer"
    :desc-3 "You can get specific by selecting makes and models"}

   :photos
   {:photos "Photos"
    :desc "Let users see what your business looks like"
    :optional "*Optional"}

   :business-information
   {:title "Business Information"
    :label {:name "Business Name"
            :email "Business Email"}
    :desc-1 "You will be added as an owner to this business account"
    :desc-2 "Customers will see your business name and email publicly when you livechat with them"
    :desc-3 "You will be able to add employees to your business account"}

   :business-personal-account
   {:title "Personal Account"
    :email {:label "Email"}
    :username {:label "Username"
               :helper "No spaces"}
    :password {:label "Password"
               :helper "At least 4 characters"}
    :desc-1 "Your personal account will be used to login to MotorSaif"
    :desc-2 "This will be linked to your business account"}

   :personal-account
   {:title "Personal Account"
    :email {:label "Email"}
    :username {:label "Username"}
    :password {:label "Password"
               :helper "At least 4 characters"}
    :desc-1 "Your personal account will be used to login to MotorSaif"}

   :whatsapp
   {
    :send-code "Send Verification Code"
    :verified "WhatsApp Verified"
    :title "Whatsapp"
    :whatsapp {:label "Whatsapp"
               :helper "UAE Number"}
    :code {:label "Whatsapp Code"
           :placeholder "Send Verification First"
           :helper "Check Whatsapp"}
    :desc "Your Whatsapp will receive notifications when a request that matches your business is posted"}


   :verify-email-new-user
   {:title "Verification"
    :code-sent "Your code was just sent to"
    :check-email " Check your email and spam folder."
    :code "Code"}})

(def dict
  {:malli malli
   :page page
   :validation
   {:new-business (:business validations)
    :edit-business (:business validations)
    :edit-request (:request validations)
    :new-request (:request validations)}

   :step-form {:submit "Submit"
               :continue "Continue"}

   :side-menu {:settings "Settings"
               :profile "Profile"
               :business-profile "Business Profile"
               :notifications "Notifications"
               :admin "Admin"
               :logout "Logout"
               :role-selector
               {:personal "Personal Account"
                :business "Business Account"}}

   :push-notification
   {:new-request
    {:title "New %1 Request" ;; Request for <biz name>
     :body "From @%1 - %2 %3 %4"} ;; Part request for 2007 honda civic
    }


   :time-ago
   {:day "%1 day ago"
    :days "%1 days ago"
    :hour "%1 hour ago"
    :hours "%1 hours ago"
    :minute "%1 minute ago"
    :minutes "%1 minutes ago"
    :seconds "%1 secs ago"
    :just-now "Just now"}

   :user
   {:status {:verified "Verified"
             :unverified "Unverified"}}

   :categories
   {:repairs "Repairs"
    :modifications "Modifications"
    :parts "Parts"}

   :footer
   {:test "%1 hey"
    :motorsaif "MotorSaif"
    :for-biz "For Businesses"
    :browse "Browse Requests"
    :profile "Profile"
    :messages "Messages"
    :new-request "New Request"
    :account "Account"
    :login "Login"
    :sign-up "Sign Up"
    :usage "Usage"
    :about "About"
    :terms "Terms"
    :partners "Partners"
    :privacy-policy "Privacy Policy"
    :sayartii.com "Sayartii.com"}

   :nav
   {:profile "Profile"
    :welcome "Welcome"
    :home "Home"
    :new-request "New Request"
    :messages "Messages"
    :preview "Preview Feed"
    :register "Sign In / Register"}

   :step-inputs step-inputs
   :domain
   {:request {:status {:state {:expired "Expired"
                               :active "Active"
                               :deleted "Deleted"
                               :resolved "Resolved"}
                       :action {:active "Activate"
                                :deleted "Delete"
                                :resolved "Resolve"}}}

    :request-type
    {:repair "Repair"
     :part "Part"
     :upgrade "Upgrade"}

    :part-condition
    {:new "New"
     :used "Used"
     :either "New or Used"}}
   :forms
   {:forgot-password {:email-placeholder "Email"
                      :submit {:button "Send Code"
                               :email-not-registered "Email not registered"}}


    :sign-up {:username {:description "Your username is unique and will be visible to everyone."
                         :placeholder "User Name"
                         :available "Available"
                         :taken "Username Taken"}
              :email {:placeholder "Email"}
              :password {:placeholder "Password"}
              :existing-account {:have "Already have an account? "
                                 :sign-in "Sign in"}
              :submit {:button "Continue"
                       :already-registered {:title "Already registered"
                                            :message "This email has been previously registered. Click to login."}}}

    :login  {:identity-placeholder "Username or Email"
             :password-placeholder "Password"
             :submit {:button "Login"
                      :wrong-credentials "Wrong username or password"}
             :forgot-password "Forgot Password"
             :sign-up {:new "New to MotorSaif?"
                       :create "Create account"}
             :create-account "Create"}

    :edit-profile {:username {:title       "Username"
                              :description "Unique username that only belongs to you"}

                   :name     {:title       "Name"
                              :description "Your real name"}

                   :email    {:title "Email"}

                   :phone    {:title       "Phone"
                              :description "We won't display your phone publicly"}

                   :password {:change  {:title       "Change Password"
                                        :description "Optionally change your password"}
                              :confirm {:title "Confirm Password"}}

                   :submit {:button "Update Information"}}

    :car {:title "Car Details"
          :choose "Choose Car"
          :new "Add New"
          :year {:title "Year"
                 :placeholder "Select Year"}
          :make {:title "Make"
                 :placeholder "Select Make"}
          :model {:title "Model"
                  :placeholder "Select Model"}
          :vin {:title "VIN"
                :placeholder "Vehicle ID Number"
                :description "17 character length code - Optional"}}

    :request {:upgrade {:category {:title "Category"
                                   :description "Choose a category that best suits the upgrade you want"}
                        :textarea {:title "Description"
                                   :description "How would you like to upgrade your car"
                                   :placeholder "Turbo, sound system, infotainment, etc"}}

              :repair {:category {:title "Category"
                                  :description "Choose a category that best suits the repair you want done"}
                       :textarea {:title "Description"
                                  :description "Describe what needs to be repaired"
                                  :placeholder "What's wrong with your car"}}

              :part {:category {:title "Category"
                                :description "Choose a category that best fits the parts you need"}
                     :textarea {:title "Description"
                                :description "Briefly describe what you need"
                                :placeholder "What parts do you want"}
                     :condition {:title "Condition"
                                 :description "What condition do you want your parts"}}

              :posting-as {:title "Posting As"
                           :personal "%1 (Personal)"
                           :business "%1 (Business)"}
              :request-type "Request type"
              :choose-request-type "Choose a request type to continue"
              :media {:title "Media"
                      :description "Optionally upload some photos"}
              :gps {:locating "Locating"
                    :jump "Jump to current location"}
              :location {:title "Location"
                         :drop-pin "Drop a pin on your current location"
                         :description "Your exact location will be private, used to find businesses closest to you"}}

    :general
    {:create "Create"
     :optional "Optional"
     :backend-error "Backend server error"
     :save "Save"}}

   :install-pwa
   {:title "Stay on top of requests with the app"
    :button "Install"}

   :general
   {:english "English"
    :loading "Loading"
    :request "Request"
    :unread "Unread: "
    :hold-to-confirm "Hold to confirm"
    :filters "Filters"
    :arabic "Arabic"
    :arabee "العربية"
    :urdu "اردو"
    :offline "Offline - Reconnecting..."}
   })
